import { ChangeDetectionStrategy, Component, ElementRef, inject, input, model, output } from '@angular/core';
import {
  ActivitySectionDirective,
  IMenuWithPages,
  MenuImageComponent,
  UserActivityClickTrackingDirective,
} from '@core';
import { PageHeaderBackSwipeConfig, PageHeaderComponent } from '@app/components/page-header/page-header.component';

@Component({
  selector: 'app-menu-detail',
  templateUrl: 'detail.component.html',
  styleUrl: 'detail.component.scss',
  imports: [
    UserActivityClickTrackingDirective,
    ActivitySectionDirective,
    PageHeaderComponent,
    MenuImageComponent,
  ],
  host: {
    'class': 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailComponent {

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    element: this.elementRef.nativeElement,
  };

  public readonly back = output();
  public readonly menus = input.required<IMenuWithPages[]>();
  public readonly current = model.required<IMenuWithPages>();

}
